import type { Dispatch, AnyAction } from 'redux';

import type FieldReportAccessVM from 'ab-viewModels/fieldReportAccess/fieldReportAccessByWorkOrder.viewModel';

import type AccessRequestModel from 'ab-requestModels/fieldReport/fieldReportAccess.requestModel';

import type { GetRootState } from 'af-reducers';

import { errorHandler } from 'af-utils/actions.util';
import { http } from 'af-utils/http.util';

import API from 'af-constants/routes/api';

export function findAllByWorkOrderId(workOrderId: number) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {
		const action = async () => {
			return await http.get<FieldReportAccessVM[]>(API.V1.FIELD_REPORT_ACCESS.FIND_BY_WORK_ORDER_ID(workOrderId));
		};
		return await errorHandler(action, dispatch, redirectTo);
	};
}

export function update(workOrderId: number, accesses: AccessRequestModel) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {
		const action = async () => {
			return await http.post<void>(API.V1.FIELD_REPORT_ACCESS.BULK_UPDATE(workOrderId), accesses);
		};
		return await errorHandler(action, dispatch, redirectTo);
	};
}
